import { useApiInspectionsV1List } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type InspectionChoice = {
  id: number;
  slug: string;
};

export type InspectionAutocompleteProps = Omit<AutocompleteFieldProps<InspectionChoice>, 'options' | 'defaultValue'> & {
  defaultValue?: InspectionChoice['id'];
};

export const InspectionAutocomplete = ({ defaultValue, ...props }: InspectionAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiInspectionsV1List({
    search: query,
  });

  return (
    <AutocompleteField<InspectionChoice>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => item.slug}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      data-testid="inspection-autocomplete"
      {...props}
    />
  );
};
